import React from 'react';

interface ProductsTooltipRootProps {
  children: React.ReactNode;
}

const ProductsTooltipRoot = ({ children }: ProductsTooltipRootProps) => <>{children}</>;

export { ProductsTooltipRoot };
